import {
  GetCollaboratorResumeResponse,
  UpdateCollaboratorResumeRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CollaboratorsResumeService = {
  async get(collaboratorId: number): Promise<GetCollaboratorResumeResponse> {
    const response = await httpClient.get<GetCollaboratorResumeResponse>(
      `v1/collaborators/${collaboratorId}/resume`,
    );
    return response;
  },
  async update(
    collaboratorId: number,
    body: UpdateCollaboratorResumeRequest,
  ): Promise<void> {
    await httpClient.put(`v1/collaborators/${collaboratorId}/resume`, body);
  },
};

export default CollaboratorsResumeService;
